import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    keepOpenOnSubmit: Boolean,
    url: String,
  }

  connect() {
    this.syncUrl()
  }

  stopSubmitEnd(event) {
    if (!this.keepOpenOnSubmitValue) return
    if (!event.detail.success) return

    event.stopPropagation()
  }

  urlValueChanged() {
    this.syncUrl()
  }

  syncUrl() {
    if (!this.hasUrlValue) return
    if (document.body.getAttribute("data-turbo-modal-history-advanced") !== "true") return
    if (window.location.pathname + window.location.search === this.urlValue) return

    window.history.replaceState({}, "", this.urlValue)
  }
}
